<template>
  <div :class="['progress-bar__container', {'isIE': this.isIE}]" :style="[this.progressWrapperCalcPadding, this.progressWrapperCalcHeight]" ref="container">
    <div class="sidebar_patient">
      <div class="sidebar_patient-content">

        <!--    SUSAN IMAGES   -->
        <transition name="fade">
          <div v-show="this.currentPage.isSusan && this.currentSection.section >= 4" :class="['sidebar_patient-image', 'susan-image']">
            <img src="@/assets/img/patients/susan/susan_0.png" :class="['patient-image']" alt>
          </div>
        </transition>

        <transition name="fade">
          <div v-show="this.currentPage.isSusan && this.currentSection.section <= 5" :class="['sidebar_patient-image', 'susan-image', 'susan-image-2']">
            <img src="@/assets/img/patients/susan/susan_2.png" :class="['patient-image']" alt>
          </div>
        </transition>

        <!--    JOSEPH IMAGES   -->
        <transition name="fade">
          <div v-show="this.currentPage.isJoseph && (this.currentSection.section === 1 || this.currentSection.section === 2 || this.currentSection.section === 3)" :class="['sidebar_patient-image', 'joseph-image']">
            <img src="@/assets/img/patients/joseph/joseph_2.png" :class="['patient-image']" alt>
          </div>
        </transition>

        <transition name="fade">
          <div v-show="this.currentPage.isJoseph && this.currentSection.section >= 4" :class="['sidebar_patient-image', 'joseph-image', 'joseph-image-3']">
            <img src="@/assets/img/patients/joseph/joseph_0.png" :class="['patient-image']" alt>
          </div>
        </transition>

        <!--    GABRIELLE IMAGES   -->
        <transition name="fade">
          <div v-show="this.currentPage.isGabrielle && (this.currentSection.section === 1 || this.currentSection.section === 2 || this.currentSection.section === 3)" :class="['sidebar_patient-image', 'gabrielle-image']">
            <img src="@/assets/img/patients/gabrielle/gabrielle_0.png" :class="['patient-image']" alt>
          </div>
        </transition>

        <transition name="fade">
          <div v-show="this.currentPage.isGabrielle && this.currentSection.section >= 4" :class="['sidebar_patient-image', 'gabrielle-image', 'gabrielle-image-2']">
            <img src="@/assets/img/patients/gabrielle/gabrielle_2.png" :class="['patient-image']" alt>
          </div>
        </transition>
        <!--        -->

        <div :class="['sidebar_patient-wrapper', {'less' : this.isiState === 2}]" v-if="!this.currentPage.isHomePage">
          <div class="sp-name_container">
            <p class="sp-name" v-html="this.patients[this.patientName].name + '*'"></p>
          </div>
          <div class="sp-divider"></div>
          <div class="sp-text_container">
            <p class="sp-text" v-html="this.patients[this.patientName].story"></p>
          </div>
          <div class="sp-footnotes_container">
            <p class="sp-footnotes" v-html="sup_ml3 + this.patients[this.patientName].footnotes"></p>
          </div>
        </div>

      </div>
      <div class="sidebar_patient-footer">
        <div class="sidebar_footer" @click="toggleModal('modal-video')">
          <img src="@/assets/img/video/play_icon.svg" alt :class="['sidebar_footer-button', this.patientName]">
          <p class="sidebar_footer-text">EXPERT’S OPINION</p>
        </div>
      </div>
    </div>
    <div class="progress_bar" :class="['dot_position_' + this.currentSection.section]" :style="[this.progressBarCalcHeight, variablesCss]">
      <div class="progress_bar__mark" v-for="(item, index) in total" :id="'progress_bar__mark_' + index" :style="'top:' + (index * (100 / total)) + '%;'">
        <span @click="progressScrollTo(item - 1)" class="progress_section_number unselectable">{{ leadZero(item - 1, digits) }}</span>
      </div>
      <div class="progress_line">
        <div class="progress_bar__progress_i" v-for="(item, index) in total" :class="['dot_movement_' + index]" :style="'top:' + (index * (100 / total)) + '%; height:' + (100 / total ) + '%;'">
          <div class="progress_bar_moving"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { SweetModal } from 'sweet-modal-vue'

export default {
  name: 'progressBar',
  props: [],
  components: {
    'sweet-modal': SweetModal
  },
  data() {
    return {
      sup_ml3: '<span class="ml-5">*</span>',
      total: 8,
      digits: 2,
      options: {
        container: 'body',
        duration: 500,
        offset: -50,
        x: false,
        y: true
      },
      windowHeight: window.height
    };
  },
  computed: {
    ...mapState(['userAgent', 'currentPage', 'currentSection', 'isiHeight', 'isiState', 'patients']),
    isIE() {
      return this.userAgent.browser.name === 'ie';
    },
    dotClasses() {
      if (this.currentSection.id > 1) {
        return 'is-active';
      }
      return (this.currentSection.percentage !== null && parseFloat(this.currentSection.percentage['1']) > 85) ? 'is-active' : 'inactive';
    },
    progressBarCalcHeight() {
      if (this.isiState === 1) return true;
      if (this.userAgent.window.width <= 1024 && this.isiState !== 2 && this.userAgent.orientation === 'landscape') {
        return { 'height': 'calc(100vh - ' + parseInt(this.isiHeight) + 'px)' }
      }
      if (this.isiState === 2) {
        return { 'height': 'calc(100vh - 140px)' }
      }
      return { 'height': 'calc(100vh - 50px - ' + parseInt(this.isiHeight) + 'px)' };
    },
    progressWrapperCalcPadding() {
      if (this.isiState === 1) return true;
      if (this.userAgent.window.width <= 1024 && this.isiState !== 2 && this.userAgent.orientation === 'landscape') {
        return {
          'padding-bottom': parseInt(this.isiHeight) + 'px'
        }
      }
      if (this.isiState === 2) {
        return {
          'padding-bottom': '140px'
        }
      }
      return {
        'padding-bottom': parseInt(this.isiHeight) + 50 + 'px'
      }
    },
    patientName() {
      if (this.currentPage.isSusan) {
        return 'susan';
      } else if (this.currentPage.isJoseph) {
        return 'joseph'
      } else if (this.currentPage.isGabrielle) {
        return 'gabrielle'
      } else {
        return 'home'
      }
    },
    variablesCss() {
      return {
        "--isi-height": this.isiHeight,
      };
    },
    progressWrapperCalcHeight() {
      if (this.userAgent.window.width <= 1112 && this.userAgent.browser.name === 'safari') {
        return {
          // 'height': parseInt(this.windowHeight) + 'px'
        }
      }
    },
  },
  methods: {
    toggleModal(target) {
      let targetVideo = this.$parent.$parent.$parent.$refs[target];
      targetVideo.open();
    },
    modalClose() {
    },
    leadZero(i, lim) {
      let ii = i.toString();
      while (ii.length < lim) {
        ii = '0' + ii;
      }
      return ii;
    },
    progressHandler() {
      if (this.$route.meta.id === 0) return true;
      let divs = document.querySelectorAll('.section-divider');
      let progress = document.querySelectorAll('.progress_bar__progress_i');
      let dividerList = [], progList = [];
      dividerList.push(...divs);
      progList.push(...progress);
      this.total = dividerList.length;
      if (dividerList.length === 0) {
        this.$store.commit('SET_CURRENT_SECTION', { id: 0, section: 0, progress: 0, total: 0, percentage: 0 });
        return;
      }
      let i;
      let next = null;
      let prev = null;
      for (i = 0; i < dividerList.length; i++) {
        let y = dividerList[i].getBoundingClientRect().top;
        const koef = 0.6;
        let dist = y - (window.innerHeight * koef);
        if (dist >= 0) {
          next = dividerList[i];
          if (i > 0) {
            prev = dividerList[i - 1];
          } else {
            prev = document.querySelector('body');
          }
          let fullDist = next.getBoundingClientRect().top - prev.getBoundingClientRect().top;
          let prc = 100.0 - ((dist / fullDist) * 100);
          progList[i].firstChild.style.height = prc + '%';
          i++;
          let current = this.leadZero(i, this.digits);
          this.$store.commit('SET_CURRENT_SECTION', { id: current, section: i, progress: dist, total: dividerList.length, percentage: prc });
          break;
        } else {
          let percent = '100%';
          // if (dividerList[i].classList.contains('section-divider-active')) progList[i].firstChild.style.height = percent;
          progList[i].firstChild.style.height = percent;
        }
      }
      try {
        for (i; i < dividerList.length; i++) {
          progList[i].firstChild.style.height = '0%';
        }
      }
      catch (e) {
        console.log(e);
      }
    },
    progressScrollTo(index) {
      let element = '.quiz_main_' + this.$route.name.toLowerCase() + '_' + index;
      this.$scrollTo(element, this.options);
    },
    toggleVideo() {
      this.$store.commit('TOGGLE_VIDEO', true);
    },
    calcInnerWidth() {
      this.windowHeight = window.innerHeight;
    }
  },
  mounted() {
    this.progressHandler();
    window.addEventListener('scroll', this.progressHandler);
    window.addEventListener('scroll', this.calcInnerWidth);
    window.addEventListener('click', this.progressHandler);
  },
  destroyed() {
    window.removeEventListener('scroll', this.progressHandler);
    window.removeEventListener('scroll', this.calcInnerWidth);
    window.removeEventListener('click', this.progressHandler);
  },
  beforeDestroy() {
    this.$store.commit('SET_CURRENT_SECTION', { id: this.currentSection.id, section: this.currentSection.section, progress: 0, total: 0, percentage: 0 });
  },
  beforeRouteUpdate() {
    this.$store.commit('SET_CURRENT_SECTION', { id: this.currentSection.id, section: this.currentSection.section, progress: 0, percentage: 0 });
  },
  watch: {}
};
</script>

<style lang="scss">
:root {
  --ipad-offset: -6.8%;
  --isi-height: 159px;
  @include media("<=tablet") {
    --isi-height: 179px;
  }
}

.progress-bar__container {
  width: 25%;
  height: 100%;
  display: flex;
  position: fixed;
  top: 0;
  left: 51px;
  bottom: auto;
  overflow: hidden;
  padding-top: 50px;
  padding-bottom: 25vh;
  transition: all 1s ease-in-out;
  z-index: 10;

  @supports (-webkit-touch-callout: none) {
    height: calc(100vh - 25px);
    top: auto;
    bottom: 0;
  }
  @include media("<=tablet", "landscape") {
    left: 0;
    width: 30%;
    padding-top: 38px;
  }
  @include media("<tablet") {
    display: none;
  }

  .screentest & {
    height: 100%;
    background-color: #1c3460;
  }
}

.sidebar_patient {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  @supports (-webkit-touch-callout: none) {
    height: calc(100% + 25px);
    margin-top: -25px;
  }

  &-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(to bottom, rgba(28, 52, 96, 0), #274375 100%);
    padding-right: 28px;

    .screentest & {
      height: 474px;
    }
  }

  &-footer {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 40px;
    background-image: linear-gradient(to right, #ffffff, rgba(207, 225, 255, 0.83) 100%);
    //background: linear-gradient(to right, #e0ebfe, rgba(146, 171, 213, 0.83) 100%);

    & > * {
      position: relative;
      z-index: 10;
    }

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: block;
      opacity: 0;
      background-image: linear-gradient(to right, rgba(207, 225, 255, 0.83), #ffffff 100%);
      transition: opacity ease .5s;
      z-index: 5;
    }

    &:hover {
      &:before {
        opacity: 1;
      }
    }

    @supports (-webkit-touch-callout: none) {
      position: relative;
      z-index: 101;
      overflow: visible;
      &:before {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        height: 1000px;
        background-image: linear-gradient(to right, #ffffff, rgba(207, 225, 255, 0.83) 100%);
        transform: translateY(40px);
      }
      &:after {
        content: '';
        display: block;
        position: absolute;
        right: 0;
        top: 0;
        background-color: #9eb0cf;
        width: 28px;
        height: 1000px;
      }
    }
  }

  .screentest & {
    background-color: white;
    height: 514px;
  }
}

.sidebar_footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  padding: 0 20px;
  //
  cursor: pointer;

  .sidebar_footer-button {
    display: flex;
    flex-direction: column;
    padding: 9px 22.5px;
    border-radius: 4px;
    margin-right: 15px;
    //
    background: url("./assets/thumbnail_susan.png") no-repeat center;
    background-size: cover;

    &.susan {
      background-image: url("./assets/thumbnail_susan.png");
    }

    &.joseph {
      background-image: url("./assets/thumbnail_joseph.png");
    }

    &.gabrielle {
      background-image: url("./assets/thumbnail_gabrielle.png");
    }
  }

  .sidebar_footer-text {
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 18px;
    font-weight: bold;
    font-stretch: condensed;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #1c3460;
  }
}

.sidebar_patient-image {
  position: absolute;
  top: 160px;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1;
  overflow: hidden;
  padding-right: 28px;

  @supports (-webkit-touch-callout: none) {
    top: auto;
    bottom: 160px;
  }

  .patient-image {
    width: 100%;
    margin: 0 auto;
    max-width: 372px;

    .isIE & {
      @include media("<=1440px") {
        max-width: 320px;
      }
      @include media("<=1280px") {
        max-width: 280px;
      }
    }
  }

  &.gabrielle-image-2 {
    .isIE & {
      @include media("<=1930px", 'height<=968px') {
        top: 130px;
        @supports (-webkit-touch-callout: none) {
          top: auto;
          bottom: 130px;
        }
      }
      @include media("<=1440px") {
        top: 90px;
        @supports (-webkit-touch-callout: none) {
          top: auto;
          bottom: 90px;
        }
      }
    }
  }

  @include media("height<880px") {
    @supports not (-webkit-touch-callout: none) {
      top: 155px;
    }
  }

  @include media("height<830px") {
    @supports not (-webkit-touch-callout: none) {
      top: 120px;
    }
  }

  @include media("height<760px") {
    top: 70px;
  }

  @include media("height<690px") {
    top: 25px;
    left: 10px;
  }

  .screentest & {
    top: 100px !important;
  }
}

.sidebar_patient-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 50;
  padding: 0 0 10px 0;
  background-image: linear-gradient(to bottom, rgba(39, 67, 117, 0.1), rgba(39, 67, 117, 0.1), #274375 70%);

  &.less {
    background-image: linear-gradient(to bottom, rgba(39, 67, 117, 0.1), rgba(39, 67, 117, 0.1), #274375 60%);
  }

  @include media("<=tablet", "landscape") {
    padding-bottom: 0;
  }
}

.sp-name_container {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 20px;

  .sp-name {
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 26px;
    font-weight: normal;
    font-stretch: condensed;
    font-style: normal;
    line-height: 1.19;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    //
    text-transform: uppercase;
  }

  @include media(">1100px", "height<840px") {
    padding: 5px;
  }
}

.sp-text_container {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 20px;

  .sp-text {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.31;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
  }

  @include media(">1100px", "height<840px") {
    padding: 5px 10px;
  }
}

.sp-footnotes_container {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 20px;

  .sp-footnotes {
    font-family: 'Roboto', sans-serif;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    color: #ffffff;
  }

  @include media(">1100px", "height<840px") {
    padding: 5px 20px;
  }
}

.sp-divider {
  width: 80%;
  height: 2px;
  opacity: 0.22;
  background-color: #FFFFFF;
}

// progress bar
.progress_bar {
  position: absolute;
  top: 0;
  left: auto;
  right: 0;
  z-index: 100;
  width: 28px;
  height: 75vh;
  background-color: rgba(#1c3460, 0.3);
  transition: height 1s ease-in-out;
  @include media("<=tablet", "landscape") {
  }
  @include media("<tablet") {
    display: none;
  }
  @supports (-webkit-touch-callout: none) {
    top: auto;
    bottom: calc(var(--isi-height) + 25px);
    height: calc(100vh - var(--isi-height) - 40px) !important;
    transition: .5s;
  }

  .screentest & {
    height: 564px !important;
    max-height: 564px !important;
  }
}

.progress_line {
  z-index: 20;
  top: 0;
  height: 100%;
  position: absolute;
  left: 0;
  width: 100%;
}

.progress_bar__progress_i {
  > div {
    width: 100%;
    height: 0;
    background-image: linear-gradient(
            0deg,
            rgba(#1c3460, 0.8) 0%,
            rgba(#1c3460, 0.8) 100%
    );

    .isIE & {
      background-image: none;
      background-color: #1c3460;
    }

    box-shadow: inset 0 0 11px 0 rgba(#1c3460, 0.34);
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    position: relative;

    &.active {
      &:after {
        content: none;
      }
    }
  }

  .screentest & {
    .dot_movement_0 {
      height: 16.66%;

      .progress_bar_moving {
        height: 100%;
      }
    }
  }
}

.progress_bar__mark {
  position: absolute;
  width: 100%;
  height: 6px;
  top: 0;
  left: 0;
  z-index: 111;
  cursor: pointer;
}

.progress_section_number {
  font-family: 'Roboto', sans-serif;
  position: relative;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 0;
  text-align: center;
  line-height: 16px;
  width: 28px;
  height: 28px;
  transition: color 0.3s ease;

  &:hover {
    color: $black;
    transition: color 0.3s ease;
  }
}
</style>
